<template>
    <div>
        <div class="py-3 px-3 border-bottom d-flex justify-content-between">
            <div class="d-flex align-items-center">
                <div class="mr-3">
                    <span v-if="lesson.video_url">
                        <i class="fa fa-play-circle" title="Vídeo Aula"></i>
                    </span>
                    <span v-else>
                        <i class="fa fa-book" title="Texto"></i>
                    </span>
                </div>

                <a href="javascript:void(1)" @click="openPreview">
                    <h5 class="p-0 m-0">
                        {{ lesson.name }}
                    </h5>
                </a>
            </div>

            <div>
                <div v-if="lesson.views_count > 0" class="text-success text-sm">
                    Concluída
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['lesson', 'module'],
    components: {
    },
    methods: {
        openPreview() {
            return window.location.href = 'modules/' + this.module.id + '/lesson/' + this.lesson.id;
            //this.$root.$emit('show-lesson-preview', this.lesson);
        },
    }
}
</script>

<style scoped>

</style>
